export default ({
  crud: [
    { id_text: 'accesses', title: 'Tela de Acessos', type: 'module' },
    // Tirado o calendar para não gerar confusão, pois o calendar deveria ser exclusivamente para o agendamento, verificar como será feito depois
    // { id_text: 'calendar', title: 'Tela de Agenda', type: 'module' },
    { id_text: 'files', title: 'Tela de Arquivos', type: 'module' },
    { id_text: 'connections', title: 'Tela de Parceiros', type: 'module' },
    { id_text: 'tasks', title: 'Tela de Tarefas', type: 'module' },
    { id_text: 'tasktemplates', title: 'Tela de Modelos de Tarefa', type: 'module' },
    { id_text: 'teams', title: 'Tela de Equipes', type: 'module' },
    { id_text: 'dashboard_movement', title: 'Dashboard de Movimentação', type: 'analytic' },
    { id_text: 'report_connection', title: 'Relatório de Parcerias', type: 'analytic' },
    { id_text: 'report_participant', title: 'Relatório de Participantes', type: 'analytic' },
    { id_text: 'report_task', title: 'Relatório de Tarefas', type: 'analytic' },
    { id_text: 'dashboard_custom', title: 'Dashboard Personalizada', type: 'module' }
  ],
  report: []
})



// WEBPACK FOOTER //
// ./src/translate/pt_br/access.js